import { useEffect, useMemo } from 'react';

interface IStrongPassword {
  password: string;
  getStatus?: (status: 'strong' | 'medium' | 'weak' | 'empty') => void;
}

function getPasswordStrength(
  password: string
): 'empty' | 'weak' | 'medium' | 'strong' {
  if (!password) return 'empty';

  const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
  const mediumRegex =
    /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,})$/;

  if (strongRegex.test(password)) return 'strong';
  if (mediumRegex.test(password)) return 'medium';
  return 'weak';
}

export function StrongPassword({ password, getStatus }: IStrongPassword) {
  const strength = useMemo(() => getPasswordStrength(password), [password]);

  useEffect(() => {
    if (getStatus) {
      getStatus(strength);
    }
  }, [strength, getStatus]);

  let badgeClass = 'text-bg-secondary';
  let badgeText = 'Crie uma senha forte';

  if (strength === 'weak') {
    badgeClass = 'text-bg-danger';
    badgeText = 'Senha fraca';
  } else if (strength === 'medium') {
    badgeClass = 'text-bg-warning';
    badgeText = 'Senha moderada';
  } else if (strength === 'strong') {
    badgeClass = 'text-bg-success';
    badgeText = 'Senha forte';
  }

  return (
    <div className="d-grid">
      <ul>
        <li className="color-text">Utilize letras maiúsculas</li>
        <li className="color-text">Utilize letras minúsculas</li>
        <li className="color-text">Utilize caracteres especiais</li>
        <li className="color-text">Utilize números</li>
      </ul>
      <span className={`text-center badge ${badgeClass}`}>{badgeText}</span>
      <p className="mt-3 mb-0 fw-semibold">Não sabe como criar?</p>
      <a
        href="https://www.avast.com/pt-br/random-password-generator#pc"
        target="_blank"
        rel="noopener noreferrer"
        className="d-flex"
      >
        <i className="material-icons me-2">link</i>Avast criação de senhas
      </a>
    </div>
  );
}
